<template>
    <el-card class="mini-box-card box-d-card" >
        <template class="mini-card-header" #header>
            <span>Traveller Requirement</span>

        </template>

        <ul class="ml-0 mb-0 fa-ul text-muted">

            <li class="small">Type : {{enquiry.type}}</li>
            <li class="small">No. of Travelers :
                <span v-if="enquiry.adults && enquiry.adults>0">{{enquiry.adults}}-A </span>
                <span v-if="enquiry.childs && enquiry.childs>0">{{enquiry.childs}}-C </span>
                <span v-if="enquiry.infants && enquiry.infants>0">{{enquiry.infants}}-I </span>
            </li>
            <li class="small">Source : {{enquiry.source}}</li>
            <li class="small">Destination : {{enquiry.destinations}}</li>
            <li class="small" v-if="enquiry.type!='Flight' ">Duration : <span v-if="enquiry.type!='Visa'"> {{enquiry.nights}}N/{{enquiry.nights+1}}D </span> <span v-else> {{enquiry.nights}} Days </span> </li>
            <li class="small">{{enquiry.type=='Hotel' ? 'Check-In Date' : 'Departure Date'}} : {{enquiry.departure_date}}</li>
            <li class="small" v-if="enquiry.type!='Visa'" >{{enquiry.type=='Hotel' ? 'Check-Out Date' : 'Return Date'}} : {{enquiry.return_date}}</li>
            <li class="small">Budget : {{enquiry.budget}}</li>
            <li class="small">Services Includes : <el-tag class="mr-2" type="info" size="small" v-for="ser in enquiry.serviceincludes">{{ser}}</el-tag></li>
            <li class="small">Specific Requirements :
                <specific-requirements-display :text="enquiry.specific_requirements"></specific-requirements-display>
            </li>



        </ul>
    </el-card>


</template>

<script>
import {
    ElCard,ElTag,ElRow,ElCol,ElButton,ElSelect,ElOption
} from 'element-plus'
import SpecificRequirementsDisplay from "./SpecificRequirementsDisplay.vue";

export default {
    name: "TravellerDetailsInfo",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    components: { SpecificRequirementsDisplay, ElSelect,ElOption,ElCard,ElTag,ElRow,ElCol,ElButton },
    data() {
        return {

        }
    },
    created(){

    },
    methods:{
    }
}
</script>

<style scoped>

</style>
